/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class FacebookGroupBanner extends React.Component {
    render() {
        return (
            <div>
                <div className="icon-wrapper">
                    <i className="icon ion-alert-circled"></i>
                </div>
                <span>We can’t post to your Facebook Group. <Link to="/config/socials?group=true">Please add dlvr.it app on Facebook</Link></span>
            </div>
        );
    }
}

FacebookGroupBanner.displayName = "FacebookGroupBanner";

export default FacebookGroupBanner;
